<template>
  <div class="app-container">
    <list ref="list">
       
       
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/materialbalancesummary/list'


export default {
  name: 'materialbalancesummary',
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  
};
</script>